import { setAxiosConfig } from '@hz-insights/web-components'
import { ticketConfig } from 'utils/synchronizeTicket'

setAxiosConfig({
  baseURL: process.env.REACT_APP_API_BASEURL,
  timeout: 500000
})

ticketConfig.synchronizeCookie2LocalStorage()
